<div class="quantity-selector">
    <div class="subtract-container">
        <button type="button" (click)="subtractStep()" [disabled]="currentValue == _min.toString() || isDisabled" class="subtract-btn vox-btn vox-btn-secondary">
            <i class="icon-small-remove"></i>
        </button>
    </div>
    <div class="input-container vox-input-group vox-input-group_dense">
        <input [disabled]="isDisabled" (keydown)="onKeydown($event)" [(ngModel)]="currentValue" (ngModelChange)="onModelChange($event)"  class="vox-text-field" type="number" min="1" max="24" step="1">
    </div>
    <div class="add-container">
        <button type="button" (click)="addStep()" [disabled]="currentValue == _max.toString() || isDisabled" class="add-btn vox-btn vox-btn-secondary">
            <i class="icon-small-add"></i>
        </button>
    </div>
</div>
